import { render, staticRenderFns } from "./WorkflowFormInput.vue?vue&type=template&id=04c53191&"
import script from "./WorkflowFormInput.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports